import { useRouter } from 'next/router';
import {
  useClientAppConfigWebHandler_getFeature,
  useRentalManagerUserPropertyMultiplexWebApiHandler_details,
} from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import accessUtils from '../../../../srcLegacy/shared/utils/accessUtils';

export const useMultiplexBuildingSessionId = () => {
  const router = useRouter();

  return { multiplexBuildingSessionId: router.query.multiplexBuildingSessionId as string | undefined };
};

export const useMultiplexListingFlow = () => {
  const { multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const { isLoading, data = 'false' } = useClientAppConfigWebHandler_getFeature(
    {
      appName: 'zrm_web',
      featureName: 'canAccessMultiplexListingFlow',
    },
    {
      meta: {
        tags: ['multiplexListingFlowAccess'],
        context: {
          api: 'ClientAppConfigWebHandler',
          details: 'canAccessMultiplexListingFlow',
        },
      },
    },
  );

  const canAccessMultiplexListingFlow = accessUtils.canAccessMultiplexListingFlow({
    canAccessMultiplexListingFlowResponse: data,
  });

  const isInMultiplexListingFlow = isLoading
    ? null
    : canAccessMultiplexListingFlow && Boolean(multiplexBuildingSessionId);

  return {
    isLoading,
    isInMultiplexListingFlow,
  };
};

export const useMultiplexDetails = () => {
  const { multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const { data, error, isFetching } = useRentalManagerUserPropertyMultiplexWebApiHandler_details(
    { multiplexBuildingSessionId: multiplexBuildingSessionId ?? '' },
    {
      enabled: Boolean(multiplexBuildingSessionId),
      meta: {
        tags: multiplexBuildingSessionId
          ? ['multiplexBuildingSessionDetails', multiplexBuildingSessionId]
          : ['multiplexBuildingSessionDetails'],
        context: {
          api: 'useRentalManagerUserPropertyMultiplexWebApiHandler_details',
          details: 'useMultiplexDetails',
        },
      },
    },
  );

  return {
    data,
    isFetching,
    error,
  };
};

// Re-export from srcLegacy since these hooks are TypeScript and don't use Redux
export { default as useMultiplexPhotoCaption } from '../../../../srcLegacy/shared/hooks/queries/multiplex/useMultiplexPhotoCaption';
export { default as useMultiplexPhotoDelete } from '../../../../srcLegacy/shared/hooks/queries/multiplex/useMultiplexPhotoDelete';
export { default as useMultiplexPhotoRank } from '../../../../srcLegacy/shared/hooks/queries/multiplex/useMultiplexPhotoRank';
export { default as useMultiplexPhotoUpload } from '../../../../srcLegacy/shared/hooks/queries/multiplex/useMultiplexPhotoUpload';
export {
  default as useMultiplexSetListingCriteria,
  mapCriterionToMultiplexListingCriterionRequest,
} from '../../../../srcLegacy/shared/hooks/queries/multiplex/useMultiplexSetListingCriteria';
export { default as useMultiplexUpdate } from '../../../../srcLegacy/shared/hooks/queries/multiplex/useMultiplexUpdate';
